<template>
  <v-container fluid grid-list-sm>
    <v-row>
      <v-col cols="12" sm="9">
        <h3 class="display-1 primary--text">Technicians</h3>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn @click="createTechnician" x-large class="float-right" color="primary" fab icon>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12">
        <v-data-table :loading="isLoading" :headers="headers" :items="t" class="elevation-1 mt-5">
          <template v-slot:item.actions="{item}">
            <v-icon color="success" class="mr-2" @click="manageEntries(item)">mdi-calendar-account</v-icon>
            <v-icon color="info" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon color="error" class="mr-2" @click="archiveTechnician(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog
        v-model="entriesModal"
        persistent
        transition="dialog-bottom-transition"
        width="60%"
    >
      <v-card>
        <v-card-title>Manage Availability for {{selectedTech.name}}</v-card-title>
        <v-card-text>
          <v-btn color="success" @click="showForm = !showForm">Create Entry</v-btn>
          <div v-if="showForm">
            <v-datetime-picker label="Start Date/Time" v-model="localStartDate"
                               :timePickerProps="{format: '24hr'}">
              <template v-slot:dateIcon>
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template v-slot:timeIcon>
                <v-icon>mdi-clock-outline</v-icon>
              </template>
            </v-datetime-picker>
            <v-datetime-picker v-if="localStartDate" label="End Date/Time"
                               v-model="localEndDate"
                               :timePickerProps="{format: '24hr'}">
              <template v-slot:dateIcon>
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template v-slot:timeIcon>
                <v-icon>mdi-clock-outline</v-icon>
              </template>
            </v-datetime-picker>
            <v-select placeholder="Select Reason" label="Reason for being unavailable" :items="reasons" v-model="entry.reason"></v-select>
            <v-text-field v-if="entry.reason === 'Other'" label="Enter reason" v-model="entry.otherReason"></v-text-field>
            <v-textarea placeholder="Notes" label="Notes" v-model="entry.notes" />
            <v-checkbox label="Tick to repeat" v-model="entry.isRepeat" />
            <p v-if="entry.isRepeat">Repeats will end after 3 months</p>
            <v-select v-if="entry.isRepeat" :items="periods" label="Repeat Frequency" item-text="name" item-value="value" v-model="entry.repeatCode" />
            <v-btn :loading="savingEntry" :disabled="savingEntry" color="primary" @click="createEntry">Save Entry</v-btn>
          </div>
          <v-data-table :loading="fetchingEntries" :headers="entriesHeaders" :items="entries" class="elevation-1 mt-5">
            <template v-slot:item.startDate="{item}">
              <span>{{ item.startDate | moment('DD/MM/YYYY HH:mm') }}</span>
            </template>
            <template v-slot:item.endDate="{item}">
              <span>{{ item.endDate | moment('DD/MM/YYYY HH:mm') }}</span>
            </template>
            <template v-slot:item.reason="{item}">
              <span v-if="item.reason !== 'Other'">{{item.reason}}</span>
              <span v-if="item.reason === 'Other'">{{item.otherReason}}</span>
            </template>
            <template v-slot:item.actions="{item}">
              <v-icon color="error" class="mr-2" @click="deleteEntry(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text color="primary" @click="closeDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {EntriesHttp} from "@/http/EntriesHttp";

export default {
  name: "Technicians",
  computed: {
    ...mapState("technicians", ["appTechnicians"]),
    t: {
      get() {
        return this.appTechnicians;
      }
    }
  },
  methods: {
    ...mapActions("technicians", ["setActiveTechnician", "setManageTechnicianDialog", "setTechnicians", "setManageDeleteTechnicianDialog"]),
    ...mapMutations("app", ["setToast"]),
    async editItem(item) {
      await this.setActiveTechnician(item);
      await this.setManageTechnicianDialog(true);
    },
    async createTechnician() {
      await this.setActiveTechnician({});
      await this.setManageTechnicianDialog(true);
    },
    async archiveTechnician(item) {
      await this.setActiveTechnician(item);
      await this.setManageDeleteTechnicianDialog(true);
    },
    async manageEntries(item) {
      this.entriesModal = true;
      this.selectedTech = item;
      await this.getEntries(item._id);
    },
    closeDialog() {
      this.entries = [];
      this.selectedTech = {};
      this.entriesModal = false;
    },
    async getEntries(id) {
      this.entries = [];
      try {
        this.fetchingEntries = true;
        const { data } = await EntriesHttp.fetchEntries(id);
        this.entries = data;
      } catch (e) {
        this.setToast({color: 'error', text: e.response.data, show: true})
      } finally {
         this.fetchingEntries = false;
      }
    },
    async createEntry() {
      try {
        this.savingEntry = true;
        const entry = {...this.entry};
        entry.techId = this.selectedTech._id;
        if (entry.startDate && entry.endDate && entry.reason) {
          await EntriesHttp.createEntry(entry);
          this.setToast({color: 'success', text: 'Entry has been created', show: true})
          await this.getEntries(this.selectedTech._id);
          this.showForm = false;
        }
      } catch (e) {
        this.setToast({color: 'error', text: e.response.data, show: true})
      } finally {
        this.savingEntry = false;
      }
    },
    async deleteEntry(item) {
      try {
        await EntriesHttp.deleteEntry(item._id);
        this.setToast({color: 'success', text: 'Entry has been deleted', show: true})
        await this.getEntries(this.selectedTech._id);
      } catch (e) {
        this.setToast({color: 'error', text: e.response.data, show: true})
      }
    }
  },
  watch: {
    localStartDate(newVal) {
      this.entry.startDate = this.$moment(newVal).toDate();
    },
    localEndDate(newVal) {
      this.entry.endDate = this.$moment(newVal).toDate();
    },
  },
  data() {
    return {
      isLoading: false,
      search: '',
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Email', value: 'email'},
        {text: 'Region', value: 'region'},
        {text: 'Phone', value: 'phone'},
        {text: 'Order', value: 'order'},
        {text: 'Actions', value: 'actions', sortable: false}
      ],
      entriesHeaders: [
        {text: 'Start Date', value: 'startDate'},
        {text: 'End Date', value: 'endDate'},
        {text: 'Reason', value: 'reason'},
        {text: 'Notes', value: 'notes'},
        {text: 'Actions', value: 'actions', sortable: false}
      ],
      entriesModal: false,
      entries: [],
      fetchingEntries: false,
      showForm: false,
      startMenu: false,
      endMenu: false,
      entry: {
        startDate: new Date(),
        endDate: new Date()
      },
      reasons: [
          'Holiday',
          'Sick',
          'Training',
          'Home By',
          'Unavailable',
          'Restock',
          'Other'
      ],
      periods: [
        {name: 'Daily', value: 0},
        {name: 'Weekday only', value: 1},
        {name: 'Weekend only', value: 2},
        {name: 'Weekly', value: 3},
        {name: 'Two Weekly', value: 4},
        {name: 'Monthly', value: 5},
        {name: 'Four Weekly', value: 6}
      ],
      savingEntry: false,
      selectedTech: {},
      localStartDate: null,
      localEndDate: null,
    }
  }
}
</script>

<style scoped>

</style>
